import { Routes } from "@angular/router";
import { MainComponent } from "./layout/main/main.component";
import { AuthLayoutComponent } from "./layout/auth-layout/auth-layout.component";
import { QuizLayoutComponent } from "./layout/quiz-layout/quiz-layout.component";
import { inject } from '@angular/core';
import { Router } from '@angular/router';
export const routes: Routes = [
 {
    path: "",
    pathMatch: "full",
    resolve: {
      redirect: () => {
        const router = inject(Router);
        const userType = localStorage.getItem('userType');
        const token = localStorage.getItem('NTCH_MRK_TKN');
        
        if (token && userType) {
          // Redirect to appropriate dashboard based on userType
          const dashboardPath = getDashboardPath(userType);
          router.navigate([dashboardPath]);
          return dashboardPath;
        }
        // No token, redirect to landing page
        router.navigate(['/landing-page']);
        return '/landing-page';
      }
    },
    // Empty component needed for resolve to work
    loadComponent: () => import('./modules/landing-page/landing-page.component').then(m => m.LandingPageComponent)
  },
  {
    path: "",
    component: MainComponent,
    loadChildren: () =>
      import("./modules/afterLoginpages/module-routes").then((m) => m.routes),
  },



  {
   path: "auth",
    component: AuthLayoutComponent,

    loadChildren: () =>
      import("./modules/auth/auth.routes").then((m) => m.routes),
  },

    {
   path: "",
    component: QuizLayoutComponent,

    loadChildren: () =>
      import("./modules/afterLoginpages/quiz-routes").then((m) => m.routes),
  },

{
  path: "landing-page",
  loadComponent: () =>
    import("./modules/landing-page/landing-page.component").then(
      (m) => m.LandingPageComponent
    ),
},
{
  path: "cms/:id",
  loadComponent: () =>
    import("./modules/landing-page/cms-pages/cms-pages.component").then(
      (m) => m.CmsPagesComponent
    ),
},

];
function getDashboardPath(userType: string): string {
  switch (userType.toLowerCase()) {
    case 'student':
    case 'business-member':
      return '/student-dashboard';
    case 'tutor':
      return '/tutor-dashboard';
    case 'business':
    case 'business_admin':
      return '/business-dashboard';
    default:
      return '/student-dashboard';
  }
}